import { css } from '@emotion/css';

import { Color, Font, FontWeight, Spacing } from '../../../../../../styles';

export const herebyDisclaimerContainer = css`
  ${Spacing.mt24}
`;

export const herebyDisclaimer = css`
  ${Font.sm}
  color: ${Color.Gray7};
`;

export const creditCardTermsAndReasonsLink = css`
  ${FontWeight.bold}
  color: ${Color.Gray7};
  text-decoration-line: underline;

  &:hover:not(:focus) {
    color: ${Color.Gray7};
    text-decoration-line: underline;
  }
`;
